export default "__VITE_ASSET__DLAM2dAY__"